import { render, staticRenderFns } from "./PageAdminGoNoGo.vue?vue&type=template&id=1537b112"
import script from "./PageAdminGoNoGo.vue?vue&type=script&lang=js"
export * from "./PageAdminGoNoGo.vue?vue&type=script&lang=js"
import style0 from "./PageAdminGoNoGo.vue?vue&type=style&index=0&id=1537b112&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports